// @flow

import React, { Component } from "react";
import { Header, Footer } from "components";
import { connect } from "react-redux";

import { getClassName } from "ui-kit/utils/component";
import { Loader } from "ui-kit/components";

import "./Page.scss";

const ccn = getClassName("Page");

class Page extends Component {
  render() {
    const {
      children,
      user,
      loader,
      extraClass
    } = this.props;

    return (
      <div className={ccn()}>
        <Header />
        <div className={ccn(`content${extraClass || ""}`)}>
          {!user ? <Loader /> : children}
          {user && loader && <Loader />}
        </div>
        <Footer user={user} />
      </div>
    );
  }
}


const mapStateToProps = ({ user }) => ({
  user: user.info
});

export default connect(mapStateToProps, { })(Page);



// WEBPACK FOOTER //
// ./src/components/page/Page.js